import app from './demo/app';
import getConfig, {defaultPromiseState, helpInitialState} from "~/config";

let config = getConfig();

const initialState = {
    ...app,
    models: {},
    modelCacheStatus: { ...defaultPromiseState, value: {} },
    page: 'app',
    appPage: 'auth',
    availableModels: [],
    help: helpInitialState,

    authResult: { ...defaultPromiseState, value: null },
    logoutResult: { ...defaultPromiseState, value: null },
    credentials: { username: '', password: '' },

    ui: {
        confirmNavigationMessages: [],
        currentModelId: null,
        loadedModels: [],
        searchModels: {},
        defaultViews: {},
        language: config.locale,
        fallback_language: config.fallback_locale,
        settings: {},
        activeAppBarDialog: null,
        searchTerm: '',
        activeFilteredViews: {},
    },

    locationHistory: []
};

export default initialState;